import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import type { Strings } from "../i18n/strings";
import type { Lang } from "../lib/types";
import { soundEnabled, setSoundEnabled, playChirp } from "../lib/sound";
import type { LegalKind } from "../content/legal";
import HyuhPromo from "./HyuhPromo";

const LANGS: Lang[] = ["ko", "en", "ja"];

interface Props {
  t: Strings;
  lang: Lang;
  setLang: (l: Lang) => void;
  onBack: () => void;
  onOpenLegal: (kind: LegalKind) => void;
}

// ⑪ 설정: 언어 · 소리 · 약관 · 개인정보. 계정 없음.
export default function Settings({ t, lang, setLang, onBack, onOpenLegal }: Props) {
  const [sound, setSound] = useState(soundEnabled());
  // 현재 실행 중인 버전 표시(OTA 디버깅용). 네이티브면 OTA 번들 버전 + 네이티브 버전.
  const [build, setBuild] = useState("");
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      setBuild("web");
      return;
    }
    CapacitorUpdater.current()
      .then((c) => setBuild(`OTA ${c.bundle?.version ?? "?"} · ${c.native ?? ""}`))
      .catch(() => setBuild("native"));
  }, []);
  function toggleSound() {
    const next = !sound;
    setSound(next);
    setSoundEnabled(next);
    if (next) playChirp(true);
  }
  return (
    <div className="screen settings">
      <div className="rep-header">
        <button className="navbtn" onClick={onBack}>
          ← {t.back}
        </button>
      </div>
      <div className="set-title">{t.setTitle}</div>

      <div className="set-row">
        <span>{t.setLang}</span>
        <div className="lang-toggle-row">
          {LANGS.map((L, i) => (
            <span key={L}>
              {i > 0 && <span className="sep">/</span>}
              <button className={`lang-opt ${lang === L ? "on" : ""}`} onClick={() => setLang(L)}>
                {L.toUpperCase()}
              </button>
            </span>
          ))}
        </div>
      </div>

      <div className="set-row">
        <span>{t.setSound}</span>
        <button className={`switch ${sound ? "on" : ""}`} onClick={toggleSound} aria-label="sound">
          <span className="switch-knob" />
        </button>
      </div>
      <button className="set-row set-link" onClick={() => onOpenLegal("terms")}>
        <span>{t.setTerms}</span>
        <span className="set-arrow">›</span>
      </button>
      <button className="set-row set-link" onClick={() => onOpenLegal("privacy")}>
        <span>{t.setPrivacy}</span>
        <span className="set-arrow">›</span>
      </button>

      {/* hyuh 크로스프로모(설정). 토스·미승인 iOS에선 자동 숨김. */}
      <HyuhPromo t={t} place="settings" />

      <div className="set-foot">
        {t.setNoAcct}
        {build ? ` · ${build}` : ""}
      </div>
    </div>
  );
}
